class ESACustomBlock extends HTMLElement {
  constructor() {
    super();
    this.handleSellingPlanChange = this.handleSellingPlanChange.bind(this);
  }

  connectedCallback() {
    this.commitmentWrapper = this.querySelector('.esa__commitment-options');

    // Find hidden selling plan input (global in product form)
    this.sellingPlanInput = document.querySelector('.selected-selling-plan-id');

    if (!this.sellingPlanInput || !this.commitmentWrapper) return;

    // Initial state
    this.toggleVisibility();

    // Listen for changes
    this.observeSellingPlan();
  }

  observeSellingPlan() {
    // Listen to change event (if manually triggered)
    this.sellingPlanInput.addEventListener('change', this.handleSellingPlanChange);

    // Also observe value changes (important for Shopify JS updates)
    this.observer = new MutationObserver(() => {
      this.toggleVisibility();
    });

    this.observer.observe(this.sellingPlanInput, {
      attributes: true,
      attributeFilter: ['value']
    });
  }

  handleSellingPlanChange() {
    this.toggleVisibility();
  }

  toggleVisibility() {
    const value = this.sellingPlanInput.value;

    if (value && value !== '') {
      this.commitmentWrapper.style.display = 'flex';
    } else {
      this.commitmentWrapper.style.display = 'none';
    }
  }

  disconnectedCallback() {
    if (this.sellingPlanInput) {
      this.sellingPlanInput.removeEventListener('change', this.handleSellingPlanChange);
    }
    if (this.observer) {
      this.observer.disconnect();
    }
  }
}

customElements.define('esa-custom-block', ESACustomBlock);